import React, { useState, useMemo } from "react";
import { InputField } from "../common/InputField";
import {
  formatScheduleDate,
  getSeatrcCategorySchedule,
  groupScheduleByDate,
} from "../data/seatrc2026Schedule";

export const Rundown = ({ categoryName }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const scheduleData = groupScheduleByDate(
    getSeatrcCategorySchedule(categoryName)
  );

  const filteredData = useMemo(() => {
    return scheduleData.map(day => {
      let events = day.events;

      // Filter by search query
      if (searchQuery) {
        events = events.filter(event => 
          event.activity.toLowerCase().includes(searchQuery.toLowerCase()) ||
          event.time.toLowerCase().includes(searchQuery.toLowerCase()) ||
          event.location.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      return {
        ...day,
        events
      };
    }).filter(day => day.events.length > 0);
  }, [categoryName, searchQuery]);

  if (!categoryName) {
     return (
        <div className="px-4 py-4 text-sm text-gray-600 text-center">
            No category selected.
        </div>
     );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4 px-4 pt-4">
        <h3 className="text-lg font-bold text-red-900 hidden md:block">
            {categoryName} Schedule
        </h3>
        <div className="w-full max-w-xs ml-auto">
          <InputField
            name="search"
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search rundown..."
            labelColor="text-red-800"
          />
        </div>
      </div>
      <div className="overflow-x-auto border-t border-slate-200">
        <table className="w-full table-auto divide-y divide-slate-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider w-1/4 border-r border-slate-200">
                Date
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider w-1/6 border-r border-slate-200">
                Time
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider w-1/3 border-r border-slate-200">
                Activity
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider w-1/4">
                Location
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200">
            {filteredData.length > 0 ? (
              filteredData.map((day, dayIdx) => (
                <React.Fragment key={dayIdx}>
                  {day.events.map((event, eventIdx) => {
                     const isFlagOff = event.activity.includes("Flag Off") || event.activity.includes("Start");
                     const isCutOff = event.activity.includes("Cut Off");
                     const rowColor = isFlagOff
                        ? "text-red-600 font-medium"
                        : isCutOff
                        ? "text-red-800 font-medium"
                        : "text-gray-600";
                        
                    return (
                        <tr
                          key={`${dayIdx}-${eventIdx}`}
                          className={`transition-colors duration-200 hover:bg-gray-50 ${rowColor}`}
                        >
                          {eventIdx === 0 && (
                            <td
                              rowSpan={day.events.length}
                              className="px-4 py-4 text-sm text-left align-top font-bold text-gray-800 bg-white border-r border-slate-200"
                            >
                              {formatScheduleDate(day.date)}
                            </td>
                          )}
                          <td className="px-4 py-4 text-sm text-left align-top border-r border-slate-200">
                            {event.time || "-"}
                          </td>
                          <td className="px-4 py-4 text-sm text-left align-top border-r border-slate-200">
                            <div>{event.activity}</div>
                            {event.note && (
                                <div className="text-xs text-gray-500 mt-1 italic">{event.note}</div>
                            )}
                          </td>
                          <td className="px-4 py-4 text-sm text-left align-top">
                            {event.location || "-"}
                          </td>
                        </tr>
                    );
                  })}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-8 text-sm text-gray-500 text-center"
                >
                  No schedule data available for {categoryName}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
